<template>
  <div class="ac-shipment-popup ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Terms
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container flex-column-1">
      <div v-if="pdfFile">
        <iframe
          :src="pdfFile"
          class="pdf-view"
          frameborder="0"
        />
      </div>
      <div v-else>
        <div class="ac-body-header flex-row">
          Pricing and Payment Terms
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            An invoice will be generated upon Partner signing this
            Order Form. Initial payment due
            upon receipt. SmartAC.com will ship Hardware upon
            receipt of Initial payment from
            Partner. The first billed month of Monitoring fees will
            be processed after {{ order.deploymentPeriod }} days from
            Initial payment. Thereafter, all payments due and owing
            under this Agreement shall be
            made monthly in advance through automated clearing
            house ('ACH') transfers. Inquiries
            regarding ACH transfers may be submitted to
            ar@smartac.com.
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Authorization
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            Partner is authorized as a certified reseller of SmartAC.com to residential homeowner or
            tenant “End Users” only, but may not install Hardware in commercial properties, other
            than property managed properties. The Service may not be sublicensed, resold, or
            provided for use in or for the benefit of any other entity without SmartAC.com's prior
            written consent
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Hardware and Software Services
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            Hardware: The SmartAC.com communication hub, sensors and various accessories required at
            End User premises to enable the Services. Services: Access to SmartAC.com's online
            applications as they exist for Partner and End Users. Applications currently available
            for Partner: <br>● Partner Dashboard <br>● SmartAC.com mobile PRO app <br>●
            Applications currently available for End Users: <br>● SmartAC.com mobile app
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Hardware Warranty
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            SmartAC.com provides a lifetime warranty on all hardware, which remains effective as
            long that the monthly Service fee related to that hardware is current. See SmartAC.com
            website for complete hardware warranty terms.
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Service Level Agreement
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            SmartAC.com, Inc. will use commercially reasonable efforts to ensure uptime of the
            SmartAC.com Platform is commensurate with the Service Commitment of its Cloud Provider,
            currently defined as 99.99%.
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Ownership
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            SmartAC.com owns and retains all rights to the SmartAC.com Technology and Documentation
            and is not specifically granted herein any copyright and other intellectual property
            rights. This Agreement transfers to Partner neither title to nor any proprietary or
            intellectual property rights in or to the Documentation or the Software, or any updates
            or upgrades thereto or derivative works thereof, or any copyrights, patent rights, or
            trademarks, embodied or used in connection therewith, except for the rights expressly
            granted herein. SmartAC.com will own all IP associated with the initial pilot phase and
            is free to utilize feedback from Partner to further enhance the IP, the platform
            offerings, and the hardware used in future business.
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Restrictions
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            To the maximum extent permitted by law, Partner may not: (i) reverse engineer,
            decompile, or disassemble Hardware or otherwise attempt to derive the source code; (ii)
            rent, lease, loan, sell, sublicense, distribute, transmit or otherwise transfer Hardware
            to any third party, or permit its use by any third party other than the Partner
            employees or Partners; (iii) make any copy of or otherwise reproduce it or any portion
            thereof; or (iv) make any modifications, enhancements or improvements to or otherwise
            create derivative works
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Termination
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            This contract is a firm obligation for its entire term and cannot be terminated without
            both parties agreeing. If you want to terminate this agreement before the term is over,
            you will owe a termination fee equal to all the remaining payments. The only exception
            is that you may terminate if SmartAC.com materially breaches this Agreement and does not
            cure the breach within thirty (30) days' of receiving your written notice. SmartAC.com
            can cancel this Agreement on thirty (30) days' notice if you breach your obligations
            (including by not paying amounts as they come due).
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Term and End User Data
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            This Agreement shall be effective for twenty four (24) months. Following the term, this
            Agreement shall automatically renew on a month-to-month basis unless a party gives not
            less than sixty (60) days' written notice prior to cancelling. All month-to-month terms
            are subject to a price increase. During the term, SmartAC.com agrees not to share
            Partner's End User personally identifiable information (“PII”) with outside parties
            beyond those required to enable the Services, or market any services to End Users that
            are competitive in nature to Partner. If Partner terminates this agreement as it relates
            to any End User, SmartAC.com may communicate with such End User in order to attempt to
            sell the Services directly.
          </p>
        </div>
        <div class="ac-body-header flex-row">
          Miscellaneous
        </div>
        <div class="ac-body-terms margin-top-4">
          <p>
            Arbitration. Any dispute arising under this Agreement or the termination of this
            Agreement will be subject to arbitration in the city of Houston, TX, under the
            commercial rules of the American Arbitration Association before a single arbitrator. The
            parties will share the arbitration fees equally. Any award will be enforceable in any
            court of competent jurisdiction and will not be inconsistent with the terms of this
            agreement. Nothing herein will prevent a party's application to a court of law for
            injunctive relief to prevent irreparable harm. Choice of Law; Jurisdiction. This
            Agreement will be interpreted in accordance with the laws of the State of Texas and
            applicable US federal law. The state and federal courts located in the city of Houston,
            TX will have exclusive jurisdiction and venue over any dispute or controversy arising
            from or relating to this Agreement or its subject matter. Severability. If any provision
            of this Agreement is held by a court of competent jurisdiction to be invalid or
            unenforceable, then such provision(s) will be construed, as nearly as possible, to
            reflect the intentions of the invalid or unenforceable provision(s), with all other
            provisions remaining in full force and effect. No Agency. No joint venture, partnership,
            employment, or agency relationship exists between Partner and Vendor as a result of this
            Agreement or use of the Service. No Waiver. The failure of Vendor to enforce any right
            or provision in this Agreement will not constitute a waiver of such right or provision
            unless acknowledged and agreed to by Vendor in writing. Force Majeure. Except for the
            payment by Partner, if the performance of this Agreement by either party is prevented,
            hindered, delayed or otherwise made impracticable by reason of any flood, riot, fire,
            judicial or governmental action, labor disputes, act of God or any other causes beyond
            the control of such party, that party will be excused from such to the extent that it is
            prevented, hindered or delayed by such causes. Entire Agreement. This Agreement,
            together with any applicable Schedule(s), comprises the entire agreement between
            Customer and SmartAC.com and supersedes all prior or contemporaneous negotiations,
            discussions or agreements, whether written or oral, between the parties regarding the
            subject matter contained herein. No amendment to or modification of this Agreement will
            be binding unless in writing and signed by an authorized representative of each party.
            THE WARRANTIES EXPRESSLY STATED IN THIS AGREEMENT ARE THE SOLE AND EXCLUSIVE WARRANTIES
            OFFERED BY SMARTAC.COM. THERE ARE NO OTHER WARRANTIES OR REPRESENTATIONS, EXPRESS OR
            IMPLIED, INCLUDING WITHOUT LIMITATION, THOSE OF MERCHANTABILITY OR FITNESS FOR A
            PARTICULAR PURPOSE.
          </p>
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="handleAccept"
      >
        Accept
      </button>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'PartnerOrderCheckoutTerms',
  mixins: [partnerReviewMixin],
  methods: {
    handleAccept() {
      this.changePartnerReviewValue('termsAccepted', true);
      this.toggleActionModal(false);
    },
  },
};
</script>
<style lang="scss" scoped>

.pdf-view {
  height: 400px;
  width: 100%;
}
</style>
